import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Sharp-edged content card with subtle hover lift.
 * Use inside light sections; for dark sections pass `tone="dark"`.
 */
const BrandCard = React.forwardRef(
    ({ className, tone = "light", as: Tag = "div", children, ...props }, ref) => {
        const palette =
            tone === "dark"
                ? "bg-[#2f2f2f] border border-white/10 text-white"
                : "bg-white border border-black/5 text-brand-dark";

        return (
            <Tag
                ref={ref}
                className={cn(
                    "group relative block p-6 md:p-8 shadow-sm transition-all duration-200 ease-out hover:-translate-y-1 hover:shadow-lg",
                    palette,
                    className,
                )}
                {...props}
            >
                {children}
            </Tag>
        );
    },
);
BrandCard.displayName = "BrandCard";

export { BrandCard };
